(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-filteranlagen-konfigurator"] && !Shopify.designMode) return;
  try {
    
  class FilterSystemCalculator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-calculator-form]');
      this.modeInputs = this.querySelectorAll('[name="input_mode"]');
      this.shape = this.querySelector('[name="shape"]');
      this.volumeFields = this.querySelector('[data-volume-fields]');
      this.dimensionFields = this.querySelector('[data-dimension-fields]');
      this.lengthField = this.querySelector('[data-length-field]');
      this.widthField = this.querySelector('[data-width-field]');
      this.diameterField = this.querySelector('[data-diameter-field]');
      this.shapeHint = this.querySelector('[data-shape-hint]');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.calculate();
      });
      this.form.addEventListener('input', () => this.calculate());
      this.form.addEventListener('change', () => {
        this.updateFields();
        this.calculate();
      });
      this.updateFields();
      this.calculate();
    }

    number(name) {
      const field = this.querySelector(`[name="${name}"]`);
      return Number.parseFloat(field?.value.replace(',', '.')) || 0;
    }

    format(value, digits = 1) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(value);
    }

    updateFields() {
      const mode = this.querySelector('[name="input_mode"]:checked')?.value;
      const shape = this.shape.value;
      this.volumeFields.hidden = mode !== 'volume';
      this.dimensionFields.hidden = mode !== 'dimensions';
      this.diameterField.hidden = shape !== 'round';
      this.lengthField.hidden = shape === 'round';
      this.widthField.hidden = shape === 'round';
      const hints = {
        rectangle: 'Länge × Breite × (Beckentiefe minus 10 cm)',
        round: 'Kreisfläche × (Beckentiefe minus 10 cm)',
        oval: 'Ellipsenfläche × (Beckentiefe minus 10 cm)',
        figure8: 'Achtformfläche × (Beckentiefe minus 10 cm)'
      };
      this.shapeHint.textContent = hints[shape] || '';
    }

    poolVolume() {
      const mode = this.querySelector('[name="input_mode"]:checked')?.value;
      if (mode === 'volume') return this.number('volume');
      const shape = this.shape.value;
      const length = this.number('length');
      const width = this.number('width');
      const diameter = this.number('diameter');
      const depth = Math.max(this.number('depth') - 0.1, 0);
      if (shape === 'rectangle') return length * width * depth;
      if (shape === 'round') return Math.PI * Math.pow(diameter / 2, 2) * depth;
      if (shape === 'oval') return Math.PI * length * width * depth / 4;
      if (shape === 'figure8') {
        const radius = width / 2;
        const centerDistance = length - width;
        if (radius <= 0 || centerDistance < 0 || centerDistance > 2 * radius) {
          return length * width * depth * 0.85;
        }
        const overlap = 2 * radius * radius * Math.acos(centerDistance / (2 * radius))
          - 0.5 * centerDistance * Math.sqrt(4 * radius * radius - centerDistance * centerDistance);
        return (2 * Math.PI * radius * radius - overlap) * depth;
      }
      return 0;
    }

    calculate() {
      const volume = this.poolVolume();
      const turnoverHours = Number.parseFloat(this.dataset.turnoverHours) || 5;
      const operatingPressure = Number.parseFloat(this.dataset.operatingPressure) || 0.7;
      const backwashPressure = Number.parseFloat(this.dataset.backwashPressure) || 0.3;
      const medium = this.querySelector('[name="filter_medium"]:checked')?.value || 'sand';
      const media = {
        sand: {
          label: 'Filtersand',
          maxFilterSpeed: Number.parseFloat(this.dataset.sandFilterSpeedMax) || 50,
          minBackwashSpeed: Number.parseFloat(this.dataset.sandBackwashSpeedMin) || 50,
          maxBackwashSpeed: Number.parseFloat(this.dataset.sandBackwashSpeedMax) || 60
        },
        afm: {
          label: 'AFM',
          minFilterSpeed: Number.parseFloat(this.dataset.afmFilterSpeedMin) || 15,
          maxFilterSpeed: Number.parseFloat(this.dataset.afmFilterSpeedMax) || 36,
          minBackwashSpeed: Number.parseFloat(this.dataset.afmBackwashSpeedMin) || 40,
          maxBackwashSpeed: Number.parseFloat(this.dataset.afmBackwashSpeedMax) || 50
        },
        unsure: {
          label: 'Noch offen',
          maxFilterSpeed: Number.parseFloat(this.dataset.afmFilterSpeedMax) || 36,
          minBackwashSpeed: Number.parseFloat(this.dataset.afmBackwashSpeedMin) || 40,
          maxBackwashSpeed: Number.parseFloat(this.dataset.sandBackwashSpeedMax) || 60
        }
      };
      const mediumData = media[medium];
      const maxFilterSpeed = mediumData.maxFilterSpeed;
      const minBackwashSpeed = mediumData.minBackwashSpeed;
      const maxBackwashSpeed = mediumData.maxBackwashSpeed;
      const pumpCatalog = [
        { name: 'Speck BADU Picco II', sku: '2191028038', handle: 'speck-badu-picco-ii-poolpumpe', variable: false, filterMax: 5.1, backwashMax: 6.2 },
        { name: 'Aqua TechniX Aqua Plus 4', sku: '2072040038', handle: 'aqua-technix-aqua-plus', variable: false, filterMax: 5.4, backwashMax: 9.8 },
        { name: 'Aqua TechniX Aqua Plus 6', sku: '2072060038', handle: 'aqua-technix-aqua-plus', variable: false, filterMax: 7.4, backwashMax: 12.4 },
        { name: 'Aqua TechniX Aqua Plus 8', sku: '2072080038', handle: 'aqua-technix-aqua-plus', variable: false, filterMax: 10.9, backwashMax: 15.5 },
        { name: 'Aqua TechniX Aqua Plus 11', sku: '2072110038', handle: 'aqua-technix-aqua-plus', variable: false, filterMax: 14.3, backwashMax: 19.1 },
        { name: 'Aqua TechniX Aqua Vario Plus', sku: '2072000038', handle: 'aqua-technix-aqua-vario-plus', variable: true, filterMax: 12.1, backwashMax: 16.0 },
        { name: 'AquaForte Eco IVS 75', sku: '35780-75', handle: 'aquaforte-eco-ivs-75-filterpumpe', variable: true, filterMax: 16.2, backwashMax: 18.0 },
        { name: 'AquaForte Eco IVS 100', sku: '35780-100', handle: 'aquaforte-eco-ivs-100-filterpumpe', variable: true, filterMax: 20.0, backwashMax: 21.0 },
        { name: 'AquaForte Inver-B-Quiet IQ15', sku: '35795', handle: 'aquaforte-inver-b-quiet-iq15-filterpumpe', variable: true, filterMax: 31.0, backwashMax: 31.0 },
        { name: 'AquaForte InverPro IP30 WiFi', sku: '35790-IH30-WIFI', handle: 'aquaforte-inverpro-ip30-wifi', variable: true, filterMax: 29.5, backwashMax: 29.5 },
        { name: 'Speck BADU Eco Touch-Pro II', sku: '2190008038', handle: 'speck-badu-eco-touch-pro-ii', variable: true, filterMax: 21.7, backwashMax: 27.5 },
        { name: 'Speck BADU Prime 7', sku: '2190078038', handle: 'speck-badu-prime-7', variable: false, filterMax: 8.2, backwashMax: 10.4 },
        { name: 'Speck BADU Prime 11', sku: '2190118038', handle: 'speck-badu-prime-11', variable: false, filterMax: 11.9, backwashMax: 14.4 },
        { name: 'Speck BADU Prime 13', sku: '2190138038', handle: 'speck-badu-prime-13', variable: false, filterMax: 14.5, backwashMax: 17.4 },
        { name: 'Speck BADU Prime 15', sku: '2190158038', handle: 'speck-badu-prime-15', variable: false, filterMax: 17.0, backwashMax: 20.4 },
        { name: 'Speck BADU Prime 20', sku: '2190208038', handle: 'speck-badu-prime-20', variable: false, filterMax: 20.7, backwashMax: 24.4 },
        { name: 'Speck BADU Prime Neo VS', sku: '2197203038', handle: 'speck-badu-prime-neo-vs', variable: true, filterMax: 25.8, backwashMax: 31.2 },
        { name: 'Speck BADU Top II 8', sku: '2190088138', handle: 'speck-badu-top-ii-8', variable: false, filterMax: 8.9, backwashMax: 12.8 },
        { name: 'Speck BADU Top II 12', sku: '2190128138', handle: 'speck-badu-top-ii-12', variable: false, filterMax: 12.8, backwashMax: 16.5 },
        { name: 'Speck BADU Top II 14', sku: '2190148138', handle: 'speck-badu-top-ii-14', variable: false, filterMax: 14.9, backwashMax: 18.6 }
      ];
      const candidates = [
        { diameter: 300, sand: 20 },
        { diameter: 400, sand: 50 },
        { diameter: 500, sand: 75 },
        { diameter: 600, sand: 125 },
        { diameter: 620, sand: 150 },
        { diameter: 750, sand: 225 },
        { diameter: 900, sand: 350 }
      ];
      const turnoverFlow = volume / turnoverHours;
      let selected = candidates.find((candidate) => {
        const area = Math.PI * Math.pow(candidate.diameter / 2000, 2);
        return turnoverFlow / area <= maxFilterSpeed;
      });
      if (!selected) selected = candidates[candidates.length - 1];
      const area = Math.PI * Math.pow(selected.diameter / 2000, 2);
      const minimumMediaFlow = medium === 'afm' ? area * mediumData.minFilterSpeed : 0;
      const requiredFlow = Math.max(turnoverFlow, minimumMediaFlow);
      const filterSpeed = requiredFlow / area;
      const backwashMin = area * minBackwashSpeed;
      const backwashMax = area * maxBackwashSpeed;
      const tolerance = 0.98;
      const matchingPumps = pumpCatalog.filter((pump) => {
        if (medium === 'unsure' && !pump.variable) return false;
        if (pump.variable) {
          return pump.filterMax >= requiredFlow && pump.backwashMax >= backwashMin * tolerance;
        }
        const pumpFilterSpeed = pump.filterMax / area;
        const pumpBackwashSpeed = pump.backwashMax / area;
        const minimumFilterReached = medium !== 'afm' || pumpFilterSpeed >= mediumData.minFilterSpeed;
        return pump.filterMax >= turnoverFlow
          && minimumFilterReached
          && pumpFilterSpeed <= maxFilterSpeed
          && pumpBackwashSpeed >= minBackwashSpeed * tolerance
          && pumpBackwashSpeed <= maxBackwashSpeed / tolerance;
      }).sort((first, second) => {
        const firstScore = first.filterMax + (first.variable ? 100 : 0);
        const secondScore = second.filterMax + (second.variable ? 100 : 0);
        return firstScore - secondScore;
      });
      const selectedPump = matchingPumps[0] || null;
      const bags = Math.ceil(selected.sand / 25);
      const afmKg = selected.sand * 0.84;
      const afmGrade1Only = selected.diameter < 400;
      const afmGradeBags = Math.ceil((afmGrade1Only ? afmKg : afmKg / 2) / 21);
      const output = (selector, value) => {
        const element = this.querySelector(selector);
        if (element) element.textContent = value;
      };
      output('[data-output-volume]', `${this.format(volume)} m³`);
      output('[data-output-diameter]', `Ø ${selected.diameter} mm`);
      output('[data-output-filter-speed]', `${this.format(filterSpeed)} m/h`);
      output('[data-output-medium]', mediumData.label);
      const mediumSpeeds = medium === 'sand'
        ? `Filtern bis ${maxFilterSpeed} m/h · Rückspülen ${minBackwashSpeed}–${maxBackwashSpeed} m/h`
        : medium === 'afm'
          ? `Planung bis ${maxFilterSpeed} m/h · Merkblatt 15–30 m/h · Rückspülen ${minBackwashSpeed}–${maxBackwashSpeed} m/h`
          : `Nach Auswahl einstellen · Rückspülen ${minBackwashSpeed}–${maxBackwashSpeed} m/h`;
      output('[data-output-medium-speeds]', mediumSpeeds);
      output('[data-output-filter-range]', medium === 'afm' ? `Planungsgrenze ${maxFilterSpeed} m/h · Merkblatt bis 30 m/h` : `Ausgelegt bis ${maxFilterSpeed} m/h`);
      const pumpOutput = this.querySelector('[data-output-pump]');
      const pumpFitOutput = this.querySelector('[data-output-pump-fit]');
      const pumpOutputLink = this.querySelector('[data-output-pump-link]');
      if (selectedPump) {
        pumpOutput.textContent = selectedPump.name;
        pumpOutputLink.href = `/products/${selectedPump.handle}`;
        pumpOutputLink.removeAttribute('aria-disabled');
        if (selectedPump.sku === '2191028038') {
          pumpFitOutput.textContent = 'Am 400-mm-Kessel mit Filtersand: ca. 40,6 m/h Filtern und 49,3 m/h Rückspülen.';
        } else if (selectedPump.variable) {
          pumpFitOutput.textContent = 'Die Drehzahl wird für Filter- und Rückspülbetrieb passend zur Kesselgröße eingestellt.';
        } else {
          pumpFitOutput.textContent = 'Die Kennlinie passt bei 0,7 bar Filterdruck und 0,3 bar Rückspüldruck zur gewählten Auslegung.';
        }
      } else {
        pumpOutput.textContent = 'Individuelle Pumpenauswahl erforderlich';
        pumpFitOutput.textContent = 'Für diese Kombination ist keine hinterlegte Pumpenkennlinie in beiden Betriebsarten eindeutig passend.';
        pumpOutputLink.removeAttribute('href');
        pumpOutputLink.setAttribute('aria-disabled', 'true');
      }
      if (medium === 'sand') {
        output('[data-output-fill-label]', 'Filtersand');
        output('[data-output-sand]', `${selected.sand} kg · ${bags} ${bags === 1 ? 'Sack' : 'Säcke'}`);
        output('[data-output-fill-note]', 'Körnung 0,4–0,8 mm');
      } else if (medium === 'afm') {
        output('[data-output-fill-label]', 'AFM-Füllmenge');
        output('[data-output-sand]', `ca. ${this.format(afmKg)} kg`);
        output('[data-output-fill-note]', afmGrade1Only
          ? `${afmGradeBags} ${afmGradeBags === 1 ? 'Sack' : 'Säcke'} Grade 1 bei Kesseln unter 400 mm`
          : `bei 21-kg-Gebinden: ${afmGradeBags} × Grade 1 + ${afmGradeBags} × Grade 2`);
      } else {
        output('[data-output-fill-label]', 'Filtermedium');
        output('[data-output-sand]', 'Nach Auswahl');
        output('[data-output-fill-note]', 'Füllmenge wird anschließend festgelegt');
      }
      const pumpLink = this.querySelector('[data-pump-link]');
      if (pumpLink) pumpLink.textContent = medium === 'unsure' ? 'Regelbare Filterpumpen ansehen' : 'Pumpen ansehen';
      const status = this.querySelector('[data-status]');
      const summary = this.querySelector('[data-output-summary]');
      if (volume <= 0 || turnoverFlow <= 0) {
        status.textContent = 'Eingabe prüfen';
        summary.textContent = 'Bitte geben Sie ein gültiges Beckenvolumen beziehungsweise vollständige Poolmaße ein.';
        return;
      }
      status.textContent = !selectedPump || (selected.diameter === 900 && filterSpeed > maxFilterSpeed) ? 'Beratung erforderlich' : 'Passende Auslegung';
      if (medium === 'unsure') {
        summary.textContent = selectedPump
          ? `Für ${this.format(volume)} m³ empfehlen wir mindestens einen Filterkessel mit ${selected.diameter} mm Durchmesser und die regelbare ${selectedPump.name}. Nach Wahl des Filtermediums wird die Drehzahl anhand der Pumpenkennlinie passend eingestellt.`
          : `Für ${this.format(volume)} m³ empfehlen wir mindestens einen Filterkessel mit ${selected.diameter} mm Durchmesser. Die passende regelbare Pumpe muss individuell anhand der Pumpenkennlinie ausgewählt werden.`;
      } else {
        summary.textContent = selectedPump
          ? `Für ${this.format(volume)} m³ mit ${mediumData.label} empfehlen wir mindestens einen Filterkessel mit ${selected.diameter} mm Durchmesser und die ${selectedPump.name}. Die Kennlinie wurde für Filterbetrieb und Rückspülung geprüft.`
          : `Für ${this.format(volume)} m³ mit ${mediumData.label} empfehlen wir mindestens einen Filterkessel mit ${selected.diameter} mm Durchmesser. Für die Pumpe ist eine individuelle technische Prüfung erforderlich.`;
      }
    }
  }

  if (!customElements.get('filter-system-calculator')) {
    customElements.define('filter-system-calculator', FilterSystemCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-heat-pump-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatNumber = (value, digits = 1) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits
    }).format(value);

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const filter = root.querySelector('[data-series-filter]');
      const selectionStatus = root.querySelector('[data-selection-status]');
      const minimumInput = root.querySelector('[data-sizing-minimum]');
      const recommendedInput = root.querySelector('[data-sizing-recommended]');
      const sizingSummary = root.querySelector('[data-sizing-summary]');
      const empty = root.querySelector('[data-comparison-empty]');
      const tableWrap = root.querySelector('[data-comparison-table-wrap]');
      const table = root.querySelector('[data-comparison-table]');
      const limit = Number.parseInt(root.dataset.selectionLimit, 10) || 3;
      const selected = new Map();
      let sizing = { minimum: null, recommended: null, volume: null };

      const numberValue = (input) => {
        const value = Number.parseFloat(String(input.value || '').replace(',', '.'));
        return Number.isFinite(value) && value > 0 ? value : null;
      };

      const productFromCard = (card) => ({
        id: card.dataset.id,
        title: card.dataset.title,
        url: card.dataset.url,
        image: card.dataset.image,
        price: card.dataset.price,
        series: card.dataset.series,
        warmCondition: card.dataset.warmCondition,
        heatWarm: Number.parseFloat(card.dataset.heatWarm),
        heatCold: Number.parseFloat(card.dataset.heatCold),
        copWarm: card.dataset.copWarm,
        copCold: card.dataset.copCold,
        sound: card.dataset.sound,
        airRange: card.dataset.airRange,
        waterFlow: card.dataset.waterFlow,
        voltage: card.dataset.voltage,
        connection: card.dataset.connection,
        wifi: card.dataset.wifi === 'true'
      });

      const fitFor = (product) => {
        if (!sizing.minimum && !sizing.recommended) {
          return { key: 'open', label: root.dataset.fitOpen };
        }

        const minimum = sizing.minimum || sizing.recommended;
        const recommended = sizing.recommended || minimum;
        if (product.heatCold >= recommended) {
          return { key: 'recommended', label: root.dataset.fitRecommended };
        }
        if (product.heatCold >= minimum) {
          return { key: 'minimum', label: root.dataset.fitMinimum };
        }
        if (product.heatWarm >= minimum) {
          return { key: 'warm-only', label: root.dataset.fitWarmOnly };
        }
        return { key: 'too-small', label: root.dataset.fitTooSmall };
      };

      const updateSelectionStatus = (message = '') => {
        selectionStatus.textContent = message || root.dataset.selectionCount
          .replace('__count__', selected.size)
          .replace('__limit__', limit);
      };

      const createTextCell = (tag, value, scope) => {
        const cell = document.createElement(tag);
        if (scope) cell.scope = scope;
        cell.textContent = value;
        return cell;
      };

      const renderTable = () => {
        const products = Array.from(selected.values());
        empty.hidden = products.length > 0;
        tableWrap.hidden = products.length === 0;
        table.querySelector('thead').replaceChildren();
        table.querySelector('tbody').replaceChildren();

        if (!products.length) return;

        const headerRow = document.createElement('tr');
        headerRow.append(createTextCell('th', '', 'col'));

        products.forEach((product) => {
          const th = document.createElement('th');
          th.scope = 'col';
          const content = document.createElement('div');
          content.className = 'pwt24-heat-pump-comparison__table-product';

          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            content.append(image);
          }

          const title = document.createElement('a');
          title.href = product.url;
          title.textContent = product.title;
          content.append(title);

          const actions = document.createElement('div');
          actions.className = 'pwt24-heat-pump-comparison__table-actions';
          const productLink = document.createElement('a');
          productLink.href = product.url;
          productLink.textContent = root.dataset.productLink;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = root.dataset.remove;
          remove.addEventListener('click', () => {
            const card = cards.find((item) => item.dataset.id === product.id);
            if (card) toggleSelection(card);
          });
          actions.append(productLink, remove);
          content.append(actions);
          th.append(content);
          headerRow.append(th);
        });
        table.querySelector('thead').append(headerRow);

        const rows = [
          [root.dataset.rowFit, (product) => fitFor(product).label],
          [root.dataset.rowPrice, (product) => product.price],
          [root.dataset.rowSeries, (product) => product.series],
          [root.dataset.rowWarm, (product) => `${formatNumber(product.heatWarm)} kW (${product.warmCondition})`],
          [root.dataset.rowCold, (product) => `${formatNumber(product.heatCold)} kW (A15/W26)`],
          [root.dataset.rowCopWarm, (product) => product.copWarm],
          [root.dataset.rowCopCold, (product) => product.copCold],
          [root.dataset.rowSound, (product) => product.sound],
          [root.dataset.rowAir, (product) => product.airRange],
          [root.dataset.rowFlow, (product) => product.waterFlow],
          [root.dataset.rowVoltage, (product) => product.voltage],
          [root.dataset.rowConnection, (product) => product.connection],
          [root.dataset.rowWifi, (product) => product.wifi ? root.dataset.valueYes : root.dataset.valueNo]
        ];

        rows.forEach(([label, getter]) => {
          const row = document.createElement('tr');
          row.append(createTextCell('th', label, 'row'));
          products.forEach((product) => row.append(createTextCell('td', getter(product))));
          table.querySelector('tbody').append(row);
        });
      };

      const refreshFit = () => {
        cards.forEach((card) => {
          const fit = fitFor(productFromCard(card));
          const badge = card.querySelector('[data-fit-badge]');
          card.dataset.fit = fit.key;
          badge.textContent = fit.label;
          badge.hidden = fit.key === 'open';
        });
        renderTable();
      };

      const toggleSelection = (card) => {
        const id = card.dataset.id;
        if (selected.has(id)) {
          selected.delete(id);
          card.setAttribute('aria-pressed', 'false');
          updateSelectionStatus();
          renderTable();
          return;
        }

        if (selected.size >= limit) {
          updateSelectionStatus(root.dataset.selectionLimitMessage.replace('__limit__', limit));
          return;
        }

        selected.set(id, productFromCard(card));
        card.setAttribute('aria-pressed', 'true');
        updateSelectionStatus();
        renderTable();
      };

      const applySizing = (updateUrl = true) => {
        sizing.minimum = numberValue(minimumInput);
        sizing.recommended = numberValue(recommendedInput);
        if (sizing.minimum && sizing.recommended && sizing.recommended < sizing.minimum) {
          sizing.recommended = sizing.minimum;
          recommendedInput.value = sizing.minimum;
        }

        const hasSizing = Boolean(sizing.minimum || sizing.recommended);
        sizingSummary.hidden = !hasSizing;
        sizingSummary.textContent = hasSizing
          ? root.dataset.sizingSummary
            .replace('__minimum__', sizing.minimum ? `${formatNumber(sizing.minimum)} kW` : '–')
            .replace('__recommended__', sizing.recommended ? `${formatNumber(sizing.recommended)} kW` : '–')
          : '';

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (sizing.minimum) url.searchParams.set('min', sizing.minimum);
          else url.searchParams.delete('min');
          if (sizing.recommended) url.searchParams.set('recommended', sizing.recommended);
          else url.searchParams.delete('recommended');
          window.history.replaceState({}, '', url);
        }

        refreshFit();
      };

      const series = Array.from(new Set(cards.map((card) => card.dataset.series).filter(Boolean)));
      series.forEach((name) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        filter.append(option);
      });

      filter.addEventListener('change', () => {
        cards.forEach((card) => {
          card.hidden = Boolean(filter.value) && card.dataset.series !== filter.value;
        });
      });

      cards.forEach((card) => card.addEventListener('click', () => toggleSelection(card)));
      root.querySelector('[data-apply-sizing]').addEventListener('click', () => applySizing());
      root.querySelector('[data-reset-sizing]').addEventListener('click', () => {
        minimumInput.value = '';
        recommendedInput.value = '';
        sizing = { minimum: null, recommended: null, volume: null };
        applySizing();
      });

      const params = new URLSearchParams(window.location.search);
      const minimum = Number.parseFloat(params.get('min'));
      const recommended = Number.parseFloat(params.get('recommended'));
      const volume = Number.parseFloat(params.get('volume'));
      if (Number.isFinite(minimum) && minimum > 0) minimumInput.value = minimum;
      if (Number.isFinite(recommended) && recommended > 0) recommendedInput.value = recommended;
      if (Number.isFinite(volume) && volume > 0) sizing.volume = volume;

      applySizing(false);
      updateSelectionStatus();
      renderTable();
    };

    document.querySelectorAll('[data-pwt24-heat-pump-comparison]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pwt24-heat-pump-comparison]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-pool-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatNumber = (value, digits = 1) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits
    }).format(value);

    const roundUp = (value, step) => Math.ceil(value / step) * step;

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('[data-calculator-form]');
      const results = root.querySelector('[data-results]');
      const volumeInput = form.elements.volume;
      const volumeError = root.querySelector('[data-volume-error]');
      const volumeStatus = root.querySelector('[data-volume-status]');
      const pipeSizes = [
        { label: 'D50', innerDiameter: 43 },
        { label: 'D63', innerDiameter: 55 },
        { label: 'D75', innerDiameter: 66 },
        { label: 'D90', innerDiameter: 79 },
        { label: 'D110', innerDiameter: 97 }
      ];
      const filterSizes = [400, 450, 500, 600, 650, 750, 900, 1050, 1200, 1400, 1600, 1800, 2000, 2200];

      const formElement = (name) => form.elements.namedItem(name);
      const numberValue = (name) => Number.parseFloat(formElement(name)?.value.replace(',', '.') ?? '');
      const selectedValue = (name) => formElement(name)?.value ?? '';

      root.querySelector('[data-use-volume]').addEventListener('click', () => {
        const length = numberValue('length');
        const width = numberValue('width');
        const depth = numberValue('depth');

        if (![length, width, depth].every((value) => Number.isFinite(value) && value > 0)) {
          volumeStatus.textContent = '';
          formElement('length')?.focus();
          return;
        }

        const volume = Math.round(length * width * depth * 10) / 10;
        volumeInput.value = volume;
        volumeStatus.textContent = `${root.dataset.volumeReady} ${formatNumber(volume)} m³`;
        volumeError.hidden = true;
        form.requestSubmit();
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const volume = numberValue('volume');
        if (!Number.isFinite(volume) || volume <= 0 || volume > 250) {
          volumeError.hidden = false;
          results.hidden = true;
          volumeInput.focus();
          return;
        }

        volumeError.hidden = true;
        const temperature = Math.min(32, Math.max(24, numberValue('temperature') || 28));
        const filterHours = Math.min(18, Math.max(6, numberValue('filter_hours') || 10));
        const season = selectedValue('season');
        const cover = selectedValue('cover');
        const heating = selectedValue('heating');
        const pipeLength = selectedValue('pipe_length');

        let heatFactor = 1.15;
        if (season === 'extended') heatFactor *= 1.2;
        if (cover === 'no') heatFactor *= 1.15;
        if (temperature > 30) heatFactor *= 1.15;
        else if (temperature > 28) heatFactor *= 1.08;
        else if (temperature < 27) heatFactor *= 0.95;
        if (heating === 'fast') heatFactor *= 1.15;

        const heatMinimum = roundUp(volume * 1.163 * 0.2 * heatFactor, 0.5);
        const heatRecommended = roundUp(volume * 1.163 * 0.28 * heatFactor, 0.5);
        const flowMinimum = roundUp((volume * 2.5) / filterHours, 0.5);
        const flowRecommended = roundUp((volume * 3) / filterHours, 0.5);
        const velocityLimit = 1.5;
        const nearVelocityLimit = velocityLimit * 0.9;
        const velocityFor = (innerDiameter) => {
          const radius = innerDiameter / 2000;
          return (flowRecommended / 3600) / (Math.PI * radius * radius);
        };
        const pipeSizeIndex = pipeSizes.findIndex((size) => velocityFor(size.innerDiameter) <= velocityLimit);
        const pipeSize = pipeSizeIndex >= 0 ? pipeSizes[pipeSizeIndex] : null;
        const pipeLabel = pipeSize ? pipeSize.label : `${root.dataset.pipeLarger} D110`;
        const pipeVelocity = pipeSize ? velocityFor(pipeSize.innerDiameter) : velocityFor(97);
        const recommendLargerPipe = pipeSize && (pipeLength === 'long' || pipeVelocity >= nearVelocityLimit);
        const largerPipeSize = recommendLargerPipe ? pipeSizes[pipeSizeIndex + 1] : null;
        const largerPipeLabel = largerPipeSize ? largerPipeSize.label : `${root.dataset.pipeLarger} D110`;
        const requiredFilterDiameter = Math.sqrt((4 * flowRecommended) / (Math.PI * 40)) * 1000;
        const filterSizeIndex = filterSizes.findIndex((size) => size >= requiredFilterDiameter);
        const filterMinimum = filterSizeIndex >= 0 ? filterSizes[filterSizeIndex] : roundUp(requiredFilterDiameter, 100);
        const filterNext = filterSizeIndex >= 0 && filterSizes[filterSizeIndex + 1]
          ? filterSizes[filterSizeIndex + 1]
          : filterMinimum + 200;
        const filterVelocityFor = (diameter) => {
          const radius = diameter / 2000;
          return flowRecommended / (Math.PI * radius * radius);
        };

        root.querySelector('[data-result-volume]').textContent = `${formatNumber(volume)} m³`;
        root.querySelector('[data-result-heat-min]').textContent = `${formatNumber(heatMinimum)} kW`;
        root.querySelector('[data-result-heat-recommended]').textContent = `${formatNumber(heatRecommended)} kW`;
        root.querySelector('[data-result-pump-flow]').textContent = `${formatNumber(flowMinimum)}–${formatNumber(flowRecommended)} m³/h`;
        root.querySelector('[data-result-pipe]').textContent = pipeLabel;
        root.querySelector('[data-result-pipe-note]').textContent = `${root.dataset.velocityLabel}: ${formatNumber(pipeVelocity, 2)} m/s`;
        const pipeEfficiency = root.querySelector('[data-result-pipe-efficiency]');
        pipeEfficiency.hidden = !recommendLargerPipe;
        pipeEfficiency.textContent = recommendLargerPipe
          ? `${root.dataset.pipeEfficiencyLabel}: ${largerPipeLabel}${largerPipeSize ? ` (${root.dataset.velocityLabel}: ${formatNumber(velocityFor(largerPipeSize.innerDiameter), 2)} m/s)` : ''}`
          : '';
        root.querySelector('[data-result-filter-minimum]').textContent = `Ø ${formatNumber(filterMinimum, 0)} mm`;
        root.querySelector('[data-result-filter-minimum-velocity]').textContent = `${root.dataset.filterVelocityLabel}: ${formatNumber(filterVelocityFor(filterMinimum))} m/h`;
        root.querySelector('[data-result-filter-next]').textContent = `Ø ${formatNumber(filterNext, 0)} mm`;
        root.querySelector('[data-result-filter-next-velocity]').textContent = `${root.dataset.filterVelocityLabel}: ${formatNumber(filterVelocityFor(filterNext))} m/h`;
        const comparisonLink = root.querySelector('[data-heat-pump-comparison-link]');
        const comparisonUrl = new URL(comparisonLink.getAttribute('href'), window.location.origin);
        comparisonUrl.searchParams.set('min', heatMinimum);
        comparisonUrl.searchParams.set('recommended', heatRecommended);
        comparisonUrl.searchParams.set('volume', volume);
        comparisonLink.href = `${comparisonUrl.pathname}${comparisonUrl.search}`;
        results.hidden = false;

        if (window.matchMedia('(max-width: 999px)').matches) {
          results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    };

    document.querySelectorAll('[data-pwt24-pool-calculator]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pwt24-pool-calculator]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-ratgeber-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeText = (value) => value
      .toLocaleLowerCase('de-DE')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const initialize = (root) => {
      if (root.dataset.searchInitialized === 'true') return;
      root.dataset.searchInitialized = 'true';

      const form = root.querySelector('[data-ratgeber-search-form]');
      const input = root.querySelector('[data-ratgeber-search-input]');
      const entries = Array.from(root.querySelectorAll('[data-ratgeber-entry]'));
      const emptyState = root.querySelector('[data-ratgeber-no-results]');

      if (!form || !input || entries.length === 0 || !emptyState) return;

      const filterEntries = (query, updateUrl = true) => {
        const normalizedQuery = normalizeText(query);
        let visibleEntries = 0;

        entries.forEach((entry) => {
          const matches = normalizeText(entry.textContent).includes(normalizedQuery);
          entry.hidden = !matches;
          if (matches) visibleEntries += 1;
        });

        emptyState.hidden = visibleEntries > 0;

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (query.trim()) url.searchParams.set('q', query.trim());
          else url.searchParams.delete('q');
          window.history.replaceState({}, '', url);
        }
      };

      const initialQuery = new URL(window.location.href).searchParams.get('q') || '';
      input.value = initialQuery;
      filterEntries(initialQuery, false);

      input.addEventListener('input', () => filterEntries(input.value));
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        filterEntries(input.value);
      });
    };

    document.querySelectorAll('[data-ratgeber-index]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ratgeber-index]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
